export default "__VITE_ASSET__2aa978ec__"